// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Pervasives from "../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as TicketStatus from "../../../../to-be-migrated/domain/types/order/tickets/TicketStatus.bs.js";
import * as UnorderedList from "../../../../../../library/components/unordered-list/UnorderedList.bs.js";
import * as FilterTicketForm from "./FilterTicketForm.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as TicketsRequestMapper from "../../../app/tickets/entitiy-mapper/TicketsRequestMapper.bs.js";
import * as TicketDashboardRepoManager from "../../../app/tickets/repo/TicketDashboardRepoManager.bs.js";

function getTicketStatus(status) {
  return React.createElement("div", {
              className: typeof status === "number" ? (
                  status !== 0 ? "u-color-txt-semi-dark" : "u-status-green"
                ) : ""
            }, TicketStatus.toString(status));
}

function reloadTab(filter, workspaceDispatch) {
  return Curry._1(workspaceDispatch.replaceTab, {
              TAG: /* Tickets */42,
              _0: TicketsRequestMapper.DictEncoder.execute(filter)
            });
}

function setInitState(params) {
  return {
          filter: TicketsRequestMapper.DictDecoder.execute(params),
          data: {
            TAG: /* Loading */0,
            _0: undefined
          }
        };
}

function loadData(filter, offset, dispatch, loadedData, country) {
  var tickets = offset !== undefined ? loadedData : undefined;
  Curry._1(dispatch, {
        TAG: /* BeforeDataFetch */1,
        data: {
          TAG: /* Loading */0,
          _0: tickets
        },
        filter_request: filter
      });
  var RepoInstance = TicketDashboardRepoManager.getTicketsRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchTickets, filter, offset, country);
              }), (function (res) {
                return Curry._1(dispatch, {
                            TAG: /* SetData */0,
                            data: {
                              TAG: /* Live */1,
                              _0: Pervasives.$at(Belt_Option.getWithDefault(tickets, /* [] */0), res.tickets)
                            },
                            offset: res.offset.value,
                            end_of_list: List.length(res.tickets) === 0,
                            total_items: res.total_count
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetData */0,
                            data: {
                              TAG: /* Error */2,
                              _0: error
                            },
                            offset: undefined,
                            end_of_list: false,
                            total_items: 0
                          });
              }));
}

function tableConfig(workspaceDispatch, visibleKey, showData, pageAccessType) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Status"
            },
            accessor: (function (data) {
                return {
                        TAG: /* Custom */5,
                        _0: (function (param) {
                            return getTicketStatus(data.status);
                          })
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Case No."
              },
              accessor: (function (data) {
                  return {
                          TAG: /* ActionButton */3,
                          _0: data.case_number,
                          _1: (function (param) {
                              return Curry._2(workspaceDispatch.addTab, {
                                          TAG: /* Ticket */43,
                                          case_number: data.case_number
                                        }, false);
                            })
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "CRN"
                },
                accessor: (function (data) {
                    return Belt_Option.mapWithDefault(data.crn, {
                                TAG: /* Custom */5,
                                _0: (function (param) {
                                    return null;
                                  })
                              }, (function (crn) {
                                  return {
                                          TAG: /* ActionButton */3,
                                          _0: crn,
                                          _1: (function (param) {
                                              return Curry._2(workspaceDispatch.addTab, {
                                                          TAG: /* OrderDetails */10,
                                                          _0: crn,
                                                          _1: undefined
                                                        }, false);
                                            })
                                        };
                                }));
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Geo Region"
                  },
                  accessor: (function (data) {
                      return {
                              TAG: /* Text */0,
                              _0: Belt_Option.getWithDefault(data.geo_region, "")
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Issues"
                    },
                    accessor: (function (data) {
                        return {
                                TAG: /* Custom */5,
                                _0: (function (param) {
                                    if (List.length(data.issues) === 1) {
                                      return List.hd(data.issues);
                                    } else {
                                      return React.createElement(UnorderedList.make, {
                                                  list: data.issues
                                                });
                                    }
                                  })
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Raised At"
                      },
                      accessor: (function (data) {
                          return {
                                  TAG: /* Text */0,
                                  _0: Timestamp$Catalyst.toString(data.raised_at, "DD/MM/YYYY | hh:mm A")
                                };
                        })
                    },
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        };
}

function FilterTicketConfig$T$FilterForm(Props) {
  var filter = Props.filter;
  var applyFilter = Props.applyFilter;
  var total_items = Props.total_items;
  return React.createElement(FilterTicketForm.make, {
              filter: filter,
              applyFilter: applyFilter,
              total_items: total_items
            });
}

var FilterForm = {
  make: FilterTicketConfig$T$FilterForm
};

var T = {
  setInitState: setInitState,
  pageTitle: "Filtered Tickets",
  loadData: loadData,
  reloadTab: reloadTab,
  tableConfig: tableConfig,
  FilterForm: FilterForm
};

export {
  getTicketStatus ,
  T ,
  
}
/* react Not a pure module */
